/**
 * Whether a named net-registration requirement is fulfilled (YES). Same logic as
 * `requirementsValidState` on ProjectCustomer and the other project views.
 */
export function isRequirementFulfilled(requirements, name) {
  if (!requirements) {
    return false;
  }

  const requirement = requirements.find((entry) => entry.name === name);

  return requirement && requirement.fullfilledState === 'YES' ? true : false;
}
